import type { EmbeddedSpeechifyExperience } from "https://storage.googleapis.com/speechify-api-cdn/speechifyapi.min.mjs";
import type { Dispatch, ReactNode, SetStateAction } from "react";
import { createContext, useContext, useState } from "react";

type ContextValue = {
  articleSpeechifyPlayer: OrUndefined<EmbeddedSpeechifyExperience>;
  setArticleSpeechifyPlayer?: Dispatch<SetStateAction<OrUndefined<EmbeddedSpeechifyExperience>>>;
};

const ArticleSpeechContext = createContext<ContextValue>({
  articleSpeechifyPlayer: undefined,
});

type Props = {
  children: ReactNode;
};

export const ArticleSpeechContextProvider: React.FunctionComponent<Props> = ({ children }) => {
  const [articleSpeechifyPlayer, setArticleSpeechifyPlayer] =
    useState<OrUndefined<EmbeddedSpeechifyExperience>>();
  return (
    <ArticleSpeechContext.Provider
      value={{
        articleSpeechifyPlayer,
        setArticleSpeechifyPlayer,
      }}
    >
      {children}
    </ArticleSpeechContext.Provider>
  );
};
ArticleSpeechContextProvider.displayName = "ArticleSpeechContextProvider";

export const useArticleSpeechContext = () => useContext(ArticleSpeechContext);
